// Orkestrator E5 §4 — client hook for /downloads/releases.json. Fetched in the browser only (the
// server render shows neutral copy), so the landing stays static and never shows a stale version.
import { useQuery } from '@tanstack/react-query'
import { parseReleases, type ReleasesDto } from '#/lib/releases'

export const releasesKey = ['downloads', 'releases'] as const

export function useReleases() {
  return useQuery({
    queryKey: releasesKey,
    queryFn: async (): Promise<ReleasesDto> => {
      const res = await fetch('/downloads/releases.json', { cache: 'no-cache', credentials: 'omit', signal: AbortSignal.timeout(15_000) })
      if (!res.ok) throw new Error(`releases.json ${res.status}`)
      return parseReleases(await res.json())
    },
    staleTime: 5 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
